import alerts from "src/locale/en/alerts";
import buttons from "src/locale/en/buttons";
import common from "src/locale/en/common";
import form from "src/locale/en/form";
import forms from "src/locale/en/forms";
import exampleTasks from "src/locale/en/hooks/exampleTasks";
import layout from "src/locale/en/layout";
import lists from "src/locale/en/lists";
import auth from "src/locale/en/modules/auth";
import chat from "src/locale/en/modules/chat";
import elements from "src/locale/en/modules/elements";
import envelope from "src/locale/en/modules/envelope";
import middlewares from "src/locale/en/modules/middlewares";
import network from "src/locale/en/modules/network";
import offer from "src/locale/en/modules/offer";
import onboarding from "src/locale/en/modules/onboarding";
import payments from "src/locale/en/modules/payments";
import promotion from "src/locale/en/modules/promotion";
import providers from "src/locale/en/modules/providers";
import registrations from "src/locale/en/modules/registrations";
import resume from "src/locale/en/modules/resume";
import reviews from "src/locale/en/modules/reviews";
import shareNetwork from "src/locale/en/modules/shareNetwork";
import subscription from "src/locale/en/modules/subscription";
import support from "src/locale/en/modules/support";
import tasks from "src/locale/en/modules/tasks";
import schemes from "src/locale/en/schemes";
import authView from "src/locale/en/views/auth";
import credit from "src/locale/en/views/credit";
import dashboard from "src/locale/en/views/dashboard";
import envelopeView from "src/locale/en/views/envelope";
import inbox from "src/locale/en/views/inbox";
import networkView from "src/locale/en/views/network";
import offerView from "src/locale/en/views/offer";
import paymentView from "src/locale/en/views/payment";
import profileView from "src/locale/en/views/profile";
import referralView from "src/locale/en/views/referral";
import report from "src/locale/en/views/report";
import resumeView from "src/locale/en/views/resume";
import reviewView from "src/locale/en/views/review";
import settingView from "src/locale/en/views/setting";
import shareNetworkView from "src/locale/en/views/shareNetwork";
import signerView from "src/locale/en/views/signer";
import talentView from "src/locale/en/views/talent";
import taskView from "src/locale/en/views/task";

const en = {
	common,
	form,
	schemes,
	layout,
	buttons,
	alerts,
	forms,
	payments,
	onboarding,
	registrations,
	reviews,
	tasks,
	elements,
	chat,
	lists,
	middlewares,
	network,
	offer,
	promotion,
	resume,
	envelope,
	subscription,
	support,
	auth,
	providers,
	report,
	"share-network": shareNetwork,
	"auth-view": authView,
	"credit-view": credit,
	"dashboard-view": dashboard,
	"envelope-view": envelopeView,
	"inbox-view": inbox,
	"network-view": networkView,
	"offer-view": offerView,
	"payment-view": paymentView,
	"profile-view": profileView,
	"referral-view": referralView,
	"resume-view": resumeView,
	"review-view": reviewView,
	"setting-view": settingView,
	"signer-view": signerView,
	"talent-view": talentView,
	"task-view": taskView,
	"share-network-view": shareNetworkView,
	"example-tasks-hook": exampleTasks,
};

export default en;
